import {
  useOperationsHistory,
  useOperationStatusIcons,
  useOperationTypesIcons,
} from '@/shared/api';
import type { OperationFilter, OperationHistoryParams } from '@/shared/types';

export function useOperationHistoryData(
  filter: OperationFilter,
  params: OperationHistoryParams = {}
) {
  const {
    operationsHistory,
    isOperationsHistoryLoading,
    operationsHistoryError,
  } = useOperationsHistory(filter, params);

  const { operationsStatusIconsData, isOperationStatusIconsLoading } =
    useOperationStatusIcons();

  const { operationTypeIconsData, isOperationTypesIconsLoading } =
    useOperationTypesIcons();

  return {
    operationsHistory,
    isOperationsHistoryLoading,
    operationsHistoryError,

    operationsStatusIconsData,
    isOperationStatusIconsLoading,

    operationTypeIconsData,
    isOperationTypesIconsLoading,

    isOperationsHistoryDataLoading:
      isOperationsHistoryLoading ||
      isOperationStatusIconsLoading ||
      isOperationTypesIconsLoading,
  };
}
